// extracted by mini-css-extract-plugin
module.exports = {"phone":"e2ff468f85--phone--wdCuo"};